import { useSelector } from 'react-redux';

import { setOpenedAuthModal, setParentAuthModal } from 'authOld/slices/authModalSlice';
import { HeaderModalOptions } from 'coreOld/constants';
import { useAppDispatch } from 'coreOld/hooks';
import { RootState } from 'store';

const PARENT_MODAL_TYPES = {
  [HeaderModalOptions.CREATE_PASSWORD]: [HeaderModalOptions.SET_UP_ACCOUNT],
  [HeaderModalOptions.FORGOT_PASSWORD]: [HeaderModalOptions.SIGN_IN, HeaderModalOptions.SIGN_UP],
};

export const useAuthModal = () => {
  const dispatch = useAppDispatch();

  const { openedAuthModal, parentAuthModal } = useSelector(
    (state: RootState) =>
      state.authModal as {
        openedAuthModal: HeaderModalOptions;
        parentAuthModal: HeaderModalOptions;
      }
  );

  const openAuthModal = (type: HeaderModalOptions) => {
    dispatch(setOpenedAuthModal(type));
  };

  const closeAuthModal = () => {
    dispatch(setOpenedAuthModal(null));
    dispatch(setParentAuthModal(null));
  };

  const setOpenedAsParentAuthModal = (currentType: HeaderModalOptions) => {
    if (PARENT_MODAL_TYPES[currentType]?.includes(openedAuthModal)) {
      dispatch(setParentAuthModal(openedAuthModal));
    }
  };

  return {
    openedAuthModal,
    parentAuthModal,
    openAuthModal,
    closeAuthModal,
    setOpenedAsParentAuthModal,
  };
};
